import React from 'react';
import Input from "../core/Input";
import {useForm} from "react-hook-form";


import {assetsBaseUrl, getShortUrl} from "../../services/calculationsApi";
import {mainMediaMobile, removeDotsComas, setBodyDataForPdf} from "../../services/helpers";
import {sharePdfAction} from "../../store/actions/calculatorActions";
import {useDispatch, useSelector} from "react-redux";
import {useMediaQuery} from "@react-hook/media-query";
import {getStateAsShareableLink} from "../../services/stateHelper";
import {SHARE_PDF} from "../../store/actionTypes/calculatorActionTypes";
import {FormattedMessage, useIntl} from "react-intl";


const SharePdfModal = ({ toggleOverview, toolData, componentRef }) => {
  const intl = useIntl();
  const { sharePdf } = useSelector((state) => state.calculator);
  const mediaMatches = useMediaQuery(mainMediaMobile);
  const {register, handleSubmit, formState, errors} = useForm({
    mode: 'onChange',
    defaultValues: {
      SenderName: '',
      RecipientName: '',
      RecipientEmail: '',
    }
  });
  const dispatch = useDispatch();
  const onSubmit = async (data) => {
    dispatch({
      type: SHARE_PDF,
      response: {
        state: 'mailing',
        success: true,
        message: intl.formatMessage({id: 'sharePdfModal.mailingDispatch', defaultMessage: 'Email is bezig met versturen'})
      }
    })
    const shortUrl = await getShortUrl(getStateAsShareableLink(removeDotsComas(toolData)), '&utm_source=berekening&utm_medium=email');
    const bodyData = {
      ...setBodyDataForPdf(toolData), ...{
        "senderName": data.SenderName,
        "bitlyLink" : shortUrl.link,
        "recipientName": data.RecipientName,
        "recipientEmail": data.RecipientEmail}
    }
    await dispatch(sharePdfAction(bodyData, intl.locale));
  };

  return (
  <div className="ct-step__modal-wrapper c-share-email">
    <div className={`ct-step__overview-modal-wrapper ct-step__overview-modal-wrapper--no-scroll ct-step__overview-modal-wrapper--auto
    ${mediaMatches && 'ct-step__overview-modal-wrapper--mobile' }`}>

      <div className="close-overview" onClick={toggleOverview}>
        <img src={`${assetsBaseUrl}/assets/svg/close.svg`} alt=""/>
      </div>

      <div className="ct-step__overview-modal" ref={componentRef}>
        <div ref={componentRef}>
          <div className="ct-step__overview-modal-title">
            <FormattedMessage id={'sharePdfModal.title'} defaultMessage={'Deel je berekening!'} />
          </div>
          {sharePdf.state === 'not_mailed' &&
          <form onSubmit={handleSubmit(onSubmit)}>
            <div>
              <div className="ct-step__body-subquestion">
                <FormattedMessage id={'sharePdfModal.senderName'} defaultMessage={'Naam verzender'} />
              </div>
              <Input
              className="ct-input"
              name="SenderName"
              register={register}
              error={errors.SenderName}
              validationRules={{required: true}}
              errorTitle={intl.formatMessage({id: 'sharePdfModal.senderName.errorTitle', defaultMessage: `naam verzender`})}
              />
            </div>
            <div>
              <div className="ct-step__body-subquestion">
                <FormattedMessage id={'sharePdfModal.recipientName'} defaultMessage={'Naam ontvanger'} />
              </div>
              <Input
              className="ct-input"
              name="RecipientName"
              register={register}
              error={errors.RecipientName}
              validationRules={{required: true}}
              errorTitle={intl.formatMessage({id: 'sharePdfModal.recipientName.errorTitle', defaultMessage: `naam ontvanger`})}
              />
            </div>
            <div>
              <div className="ct-step__body-subquestion">
                <FormattedMessage id={'sharePdfModal.recipientEmail'} defaultMessage={'E-mailadres ontvanger'} />
              </div>
              <Input
              className="ct-input"
              name="RecipientEmail"
              register={register}
              error={errors.RecipientEmail}
              validationRules={{required: true, pattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/ }}
              errorTitle={intl.formatMessage({id: 'sharePdfModal.recipientEmail.errorTitle', defaultMessage: `e-mailadres`})}
              />
            </div>
            <button
            className={`ct__button`}
            disabled={!formState.isValid}
            type="submit">
              <FormattedMessage id={'sharePdfModal.submit'} defaultMessage={'Verstuur'} />
            </button>
          </form>
          }

          {sharePdf.state === 'mailing' &&
          <div className="ct-step__overview-modal-subtitle">
            <FormattedMessage id={'sharePdfModal.mailing'} defaultMessage={'Bezig met het versturen van de email.'} /><br/>
            <img src={`${assetsBaseUrl}/assets/svg/loader-dots.svg`} alt="" />
          </div>
          }

          {sharePdf.state === 'mailed' &&
            <div className="ct-step__overview-modal-subtitle">
              <FormattedMessage id={'sharePdfModal.mailed'} defaultMessage={'Je e-mail is verstuurd.'} />
            </div>
          }
        </div>
      </div>
    </div>
  </div>

  );
};

export default SharePdfModal;
